import { MagnifyingGlass } from "react-loader-spinner";

export function FormsListLoading() {
    return (
        <div className="flex flex-1 flex-col items-center bg-system-white p-48 rounded-2xl">
            <MagnifyingGlass
                visible={true}
                height="80"
                width="80"
                ariaLabel="magnifying-glass-loading"
                glassColor="var(--color-secondary-blue-light)"
                color="var(--color-primary-identity-blue)"
            />
        </div>
    );
}
